import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedGrid from './components/FeaturedGrid';
import VideoSection from './components/VideoSection';
import CTASection from './components/CTASection';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '91吃瓜网',
  url: 'https://www.91chigua.com',
  description: '91吃瓜网官网实时追踪网红明星最新黑料，每日大赛热门视频在线看不停，娱乐圈爆料、社会热点大瓜第一时间更新。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.91chigua.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '91吃瓜网',
  url: 'https://www.91chigua.com',
  logo: 'https://www.91chigua.com/logo.png',
  description: '国内领先的娱乐八卦资讯平台',
  address: {
    '@type': 'PostalAddress',
    addressLocality: '北京',
    addressRegion: '北京市',
    addressCountry: 'CN',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'tips@91chigua.com',
    contactType: 'customer service',
  },
};

export default function Home() {
  return (
    <>
      <title>91吃瓜网 - 91吃瓜爆料与91吃瓜视频 | 明星网红黑料每日大赛在线观看</title>
      <meta name="description" content="91吃瓜网官网实时追踪网红明星最新黑料，每日大赛热门视频在线看不停，娱乐圈爆料、社会热点大瓜第一时间更新，吃瓜群众的必刷入口，想看最新塌房现场就别错过。" />
      <meta name="keywords" content="91吃瓜网,91吃瓜爆料,91吃瓜视频,91吃瓜在线观看,网红黑料,明星塌房,每日大赛,吃瓜群众,娱乐八卦" />
      <link rel="canonical" href="https://www.91chigua.com" />
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryNav />
          <FeaturedGrid />
          <VideoSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}